module.exports = __webpack_public_path__ + "static/media/policeman.e3504f32.svg";